export const isEmailRegistered = async (email: string) => {
  const response = await fetch(
    `${import.meta.env.VITE_API_BASE_URL}/exists/user/${email}`,
  );
  return await response.json();
};
